<template>
  <v-sheet color="transparent" height="100%" width="100%">
    <Loading v-if="loading" />

    <div v-else>
      <Slides />
      <!-- <Products /> -->
      <About />
      <Brands />
    </div>
  </v-sheet>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Slides from "./Slides.vue";
// import Products from "./Products.vue";
import About from "./About.vue";
import Brands from "./Brands.vue";

export default {
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.$rest("slides").get();
    // this.$rest("products").get({ params: { itemsPerPage: 4 } });
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });
    this.$rest("brands").get();

    this.loading = false;
  },
  components: {
    Loading,
    Slides,
    // Products,
    About,
    Brands,
  },
};
</script>
